module.exports = __webpack_public_path__ + "static/img/kangtiya.5f0d989.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/kangtiya.png
// module id = myPF
// module chunks = 1